import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

const AdminRoute = () => {
  const adminUsuario = localStorage.getItem("adminUsuario"); // 🔥 Revisamos si el admin está autenticado

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        console.log("⏳ Sesión cerrada por inactividad.");
        localStorage.removeItem("adminUsuario"); // 🔥 Elimina la sesión
        window.location.href = "/administrador"; // 🔥 Redirige al login de admin
      }, 20 * 60 * 1000); // ⏳ 5 minutos de inactividad
    };

    // ✅ Detectar actividad del usuario
    const events = ["mousemove", "keydown", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // Iniciar temporizador al cargar

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);

  return adminUsuario ? <Outlet /> : <Navigate to="/AdminLogin" replace />;
};

export default AdminRoute;
